// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bodyRow__JCJlo {
  border-color: unset;
}
.bodyRow__JCJlo:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.bodyRow__JCJlo td {
  padding: 10px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  white-space: normal;
  font-size: 14px;
  line-height: 20px;
}

.iconColumn__wXNre {
  text-align: right;
  cursor: pointer;
}
.iconColumn__wXNre path {
  stroke: var(--tables-primary-row-icon);
}

.expandRowIcon___gcma {
  outline: none;
  transition: all 0.3s ease-in-out;
}

.expandRowIconTop__SVrjM {
  transform: rotate(180deg);
}

.skeletonText__clH70 {
  height: 15px;
}

.skeletonIcon__ej7iL {
  width: 15px;
  height: 15px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/FailureCauseCategories/components/ExpandedRow/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,mBAAA;AAzEF;AA0EE;EACE,mDAAA;EACA,yDAAA;AAxEJ;AA2EE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAzEJ;;AA6EA;EACE,iBAAA;EACA,eAAA;AA1EF;AA4EE;EACE,sCAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,gCAAA;AA3EF;;AA8EA;EACE,yBAAA;AA3EF;;AA8EA;EACE,YAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,YAAA;AA3EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.bodyRow {\n  border-color: unset;\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n\n  td {\n    padding: 10px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    white-space: normal;\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n\n.iconColumn {\n  text-align: right;\n  cursor: pointer;\n\n  path {\n    stroke: var(--tables-primary-row-icon);\n  }\n}\n\n.expandRowIcon {\n  outline: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.expandRowIconTop {\n  transform: rotate(180deg);\n}\n\n.skeletonText {\n  height: 15px;\n}\n\n.skeletonIcon {\n  width: 15px;\n  height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyRow": `bodyRow__JCJlo`,
	"iconColumn": `iconColumn__wXNre`,
	"expandRowIcon": `expandRowIcon___gcma`,
	"expandRowIconTop": `expandRowIconTop__SVrjM`,
	"skeletonText": `skeletonText__clH70`,
	"skeletonIcon": `skeletonIcon__ej7iL`
};
module.exports = ___CSS_LOADER_EXPORT___;
